import { http } from "./client";

export const getClientInformation = (medicaidid) => http.get('Client/info',{params: {MedicaidID: medicaidid}});